/**
 * Applications API service
 * Handles all application field related API calls
 * Based on frontend_integration_guide.md
 */

import client from './client'

/**
 * Get applications list (Product Fields)
 * @param {Object} params - Query parameters (optional)
 * @returns {Promise<Object>} Response with { code, data: { list } }
 */
export async function getApplications(params = {}) {
  try {
    const response = await client.get('/products/fields', { params })
    return response.data
  } catch (error) {
    return handleApiError(error)
  }
}

/**
 * Get application detail by ID
 * @param {number|string} id - Application ID
 * @returns {Promise<Object>} Response with { code, data: { application object } }
 */
export async function getApplicationById(id) {
  try {
    const response = await client.get(`/applications/${id}`)
    return response.data
  } catch (error) {
    return handleApiError(error)
  }
}

/**
 * Get products by application field ID
 * This fetches all products for a specific application field
 * @param {number} applicationFieldId - Application field ID
 * @param {Object} params - Additional query parameters (page, pageSize, etc.)
 * @returns {Promise<Object>} Response with { code, data: { list, pagination } }
 */
export async function getProductsByApplicationField(applicationFieldId, params = {}) {
  try {
    const queryParams = {
      application_field_id: applicationFieldId,
      ...params
    }
    const response = await client.get('/products', { params: queryParams })
    return response.data
  } catch (error) {
    return handleApiError(error)
  }
}

/**
 * Get bundle products
 * @param {Object} params - Query parameters (optional)
 * @returns {Promise<Object>} Response data
 */
export async function getBundleProducts(params = {}) {
  try {
    const response = await client.get('/products/bundles', { params })
    return response.data
  } catch (error) {
    return handleApiError(error)
  }
}

/**
 * Handle API errors and return unified response
 * @param {Error} error - Axios error object
 * @returns {Object} Error response with code and message
 */
function handleApiError(error) {
  if (error.response?.data) {
    // API returned error response
    return error.response.data
  }

  // Network or other error
  return {
    code: 0,
    message: error.message || '请求失败，请检查网络连接'
  }
}

export default {
  getApplications,
  getApplicationById,
  getProductsByApplicationField,
  getBundleProducts
}
